export const TRANSACTION_TYPES = [
  { id: 'refueling', name: '加油 (不含條碼付）' },
  { id: 'on_street_parking', name: '路邊停車' },
  { id: 'parking', name: '停車' },
  { id: 'lease', name: '月租車位' },
];

export const getTransactionTypeIds = transactionTypes => {
  const defaultTransactionTypes = TRANSACTION_TYPES.map(x => x.id);
  return transactionTypes.length === 0 ? defaultTransactionTypes : transactionTypes;
};

export const getTransactionTypeNames = transactionTypes => {
  if (transactionTypes.length === 0) {
    return [];
  } else {
    return TRANSACTION_TYPES.filter(x => transactionTypes.includes(x.id)).map(x => x.name);
  }
};

export const transactionTypeParams = transactionTypes => {
  return getTransactionTypeIds(transactionTypes).join(',');
};
